import { Paths } from "../constants/UrlConstants";
import { ButtonConfig, InboxPages } from "../constants/Constants";

const GeneralEnquirySmartLink = {
  linkText: "General enquiry",
  pathTo: `${Paths.MessageCentre}?page=${InboxPages.GeneralQuery}`,
  iconName: "icon-functional-email",
  id:ButtonConfig.GeneralEnquiry
};

export default GeneralEnquirySmartLink;
